import React from 'react'
import '../Order/orders.css'
import Button from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import TimeTextField from '../../../Components/timeTextField/TimeTextField'
import TextField from '../../../Components/textField/textField.js'
import '../general.css'
import Alert from '../../../Components/alert/Alert'
import Select from '../../../Components/select/select';
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";

export default class altOp extends React.Component {
    state = {
        id:null,arrayWorkShifts:[],initHour:null,finalHour:null,arr_idcodes:[],description:"",
        show: false,
        message:"",
        readOnly: true,
        notification: false,
        notification_type: 'success',
        notification_message: '',
        control: [1],
        days: [false,false,false,false,false,false,false],
        auxdays:[0,1,2,3,4,5,6]

    }

   
    

    componentDidMount() {
        Api.get('/work-shifts/').then((resp) => {
            let arr_codes = []
            let arr_ids = []
            resp.data.forEach(element => {
                arr_codes.push({ value: element.id, label:element.code })
                arr_ids.push({ id: element.id, code: element.code })
            });
            this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids })
        }).catch((error) => {
            if (error.response) {
                alert(error.response.data + '\n' + error.response.status + '\n' + error.response.headers)
            }
        })    
    }

    changeValueCode = (data) => { 
        const {id} =  this.state.arr_idcodes.find(value => value.id === data);

        this.setState({readOnly: false});
        
        Api.get(`/work-shifts/${id}`).then(resp=>{
            let {id,code,start_time,end_time,days} = resp.data;
            let temparr = this.state.days;
            console.log(resp)
            if(days.length > 0){
                this.state.auxdays.forEach((value,i)=>{
                    let data = days.split(",").find((ele)=>{return ele == value});
                    if(data !== undefined){
                        temparr[i] = true;
                    }else{
                        temparr[i]=false;
                    }
                });
            }else{
                temparr = temparr.map(() => false);
            }  
            this.setState({id:id,description:code,initHour:start_time,finalHour:end_time,days:temparr});
        }).catch(err=>{
            alert(err)
        })
    }

    changeValueInitHour = (data) => { this.setState({ initHour: data }) }
    changeValueFinal    = (data) => { this.setState({ finalHour: data })}
    showMessage         = () => { this.setState({ show: false }) }
    callbackFunction    = (value) => { this.setState({ description: value })}
    callbackDay = (day)=>{
        let daysWeek = this.state.days;
        if(daysWeek[day] === false){
            daysWeek[day] = true;
        }else{
            daysWeek[day] = false;
        }

        this.setState({days: daysWeek})
    }

    sendData = () => {
        if(this.state.id !== null && ((this.state.description !== null && this.state.description !== "") && (this.state.initHour !== null && this.state.initHour !== "") && (this.state.finalHour !== null && this.state.finalHour !== ""))){
            let daysWeek = "";
            
            (this.state.days[0] == true) ? (daysWeek = daysWeek + "0,"):(<></>);
            (this.state.days[1] == true) ? (daysWeek = daysWeek + "1,"):(<></>);
            (this.state.days[2] == true) ? (daysWeek = daysWeek + "2,"):(<></>);
            (this.state.days[3] == true) ? (daysWeek = daysWeek + "3,"):(<></>);
            (this.state.days[4] == true) ? (daysWeek = daysWeek + "4,"):(<></>);
            (this.state.days[5] == true) ? (daysWeek = daysWeek + "5,"):(<></>);
            (this.state.days[6] == true) ? (daysWeek = daysWeek + "6,"):(<></>);

            Api.put(`/work-shifts/${this.state.id}`, {
                code: this.state.description,
                start_time: this.state.initHour,
                end_time: this.state.finalHour,
                days: daysWeek
            }).then((resp) => {
                this.setState({notification: true, notification_message: "Turno editado com sucesso!"});
                setTimeout(()=>{
                    return window.location.reload();
                },2000)
            }).catch(error => {
                if (error.response) {
                    alert(error.response.data + '\n' + error.response.status + '\n' + error.response.headers)
                }
            })
        }else{
            this.setState({show:true,message:"Verifique se preencheu todos os dados corretamente!"})
        } 
    }

    render() {
        let {show,message, notification, notification_message, notification_type} = this.state
        return (
            <div className='box'>
                {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                <div className="mot_del_reason form" >
                <h4>Alterar Turno</h4>
                    {show ? <Alert show={show} message={message} parentCallback={this.showMessage} /> : null}
                    <div className='inputs'>
                        <div className='select element'><Select autoSelect={true} label="Turno" arrData={this.state.arrayWorkShifts} handleSelect={this.changeValueCode} /></div>
                        <div className='element'><TextField readOnly={this.state.readOnly} section="false" title="Descrição" name="description" min={3} max={20} parentCallback={this.callbackFunction} value={this.state.description} altType={true} validationType="varchar"/></div>
                        <div className="element"><TimeTextField disabled={this.state.readOnly} title="Hora de início"  value={this.state.initHour} seconds parentCallback={this.changeValueInitHour}></TimeTextField></div>
                        <div className="element"><TimeTextField disabled={this.state.readOnly} title="Hora de término" value={this.state.finalHour} seconds parentCallback={this.changeValueFinal}></TimeTextField></div>
                        {this.state.control.length >= 1 ? (
                            <div className='checkboxs days'>
                                <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="domingo" checked={(this.state.days[0] == true) ? (true):(false)} id="flexCheckDefault"  onClick={(event)=>{this.callbackDay(0)}}/>
                                    <label className="form-check-label" for="domingo">
                                        Domingo
                                    </label>
                                </div>
                                <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="segunda" value="segunda" id="flexCheckDefault" checked={this.state.days[1]} onChange={()=>{this.callbackDay(1)}}/>
                                    <label className="form-check-label" for="segunda">
                                        Segunda
                                    </label>
                            </div>
                            <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="terca" value="terca" id="flexCheckDefault" checked={this.state.days[2]} onChange={()=>{this.callbackDay(2)}}/>
                                    <label className="form-check-label" for="terca">
                                        Terça
                                    </label>
                            </div>
                            <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="quarta" value="quarta" id="flexCheckDefault" checked={this.state.days[3]} onChange={()=>{this.callbackDay(3)}}/>
                                    <label className="form-check-label" for="quarta">
                                        Quarta
                                    </label>
                            </div>
                            <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="quinta" value="quinta" id="flexCheckDefault" checked={this.state.days[4]} onChange={()=>{this.callbackDay(4)}}/>
                                    <label className="form-check-label" for="quinta">
                                        Quinta
                                    </label>
                            </div>
                            <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="sexta" value="sexta" id="flexCheckDefault" checked={this.state.days[5]} onChange={()=>{this.callbackDay(5)}}/>
                                    <label className="form-check-label" for="sexta">
                                        Sexta
                                    </label>
                            </div>
                            <div className="form-check element">
                                    <input className="form-check-input" type="checkbox" name="sabado" value="sabado" id="flexCheckDefault" checked={this.state.days[6]} onChange={()=>{this.callbackDay(6)}}/>
                                    <label className="form-check-label" for="sabado">
                                        Sábado
                                    </label>
                            </div>

                            </div>):(<></>)}
                    </div>
                    <div className='btnAltWorkShift submitButton'><Button title="Alterar" parentCallback={this.sendData} /></div>
                </div>
            </div>
        );
    }
}
